<template>
    <div class="position-relative">
        <div :class="{ dropdown: !hideDropdown }" v-if="isLoggedIn">
            <a href="#" class="nav-link" :class="{ 'dropdown-toggle': !hideDropdown }" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg v-if="!noIcons" xmlns="http://www.w3.org/2000/svg" width="31.193" height="31.193" viewBox="0 0 31.193 31.193">
                    <path data-name="account" d="M21.6,26.216c8.614,0,15.6,3.258,15.6,7.278v5.2H6v-5.2C6,29.474,12.983,26.216,21.6,26.216ZM21.6,7.5a7.278,7.278,0,1,1-7.278,7.278A7.278,7.278,0,0,1,21.6,7.5Z" transform="translate(-6 -7.5)" fill="#fff"/>
                </svg>

                <span v-if="!smallStyle" class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100" v-if="!hideDropdown" >
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <svg v-if="!noIcons" xmlns="http://www.w3.org/2000/svg" width="31.193" height="31.193" viewBox="0 0 31.193 31.193">
                    <path data-name="iconLogin1" d="M21.6,26.216c8.614,0,15.6,3.258,15.6,7.278v5.2H6v-5.2C6,29.474,12.983,26.216,21.6,26.216Zm13.517,7.278c0-2.87-6.052-5.2-13.517-5.2S8.08,30.625,8.08,33.494v3.119H35.114ZM21.6,7.5a7.278,7.278,0,1,1-7.278,7.278A7.278,7.278,0,0,1,21.6,7.5Zm0,2.08a5.2,5.2,0,1,0,5.2,5.2,5.2,5.2,0,0,0-5.2-5.2Z" transform="translate(-6 -7.5)" fill="#fff"/>
                </svg>

                <span v-if="!smallStyle" class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
            </a>
            <template v-if="showRegistration">
                <span class="pipe" v-if="!showLogin"></span>
                <a class="nav-link" data-testing="register-select" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'"  @click="createRegisterModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.loginRegister')">
                    <i v-if="!noIcons" class="fa fa-user-plus mr-1" aria-hidden="true"></i>
                    <span v-if="!smallStyle" class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        },
        smallStyle: {
            type: Boolean,
            default: false
        },
        hideDropdown: {
            type: Boolean,
            default: false
        },
        noIcons: {
            type: Boolean,
            default: false
        }

    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
